import { CategoryRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { Category, CreateCategoryType } from "@utilities/types";

export const categoryService = {
    create: async (category: CreateCategoryType) => {

        const formData = new FormData();
        formData.append("name", category.name);
        formData.append("organisationID", category?.organisationID!);
        formData.append("file", category.file, category.file.name);

        return await fetchRequest({
            route: CategoryRoutesEnum.CATEGORY_CREATE,
            method: "POST",
            data: formData,
            isFormData: true,
        });
    },

    getAll: async (organisationId: string) => {
        return await fetchRequest({
            route: `${CategoryRoutesEnum.CATEGORY_GET_ALL_ORGANISATION_CATEGORIES}/${organisationId}`,
            method: "GET",
        });
    },

    update: async (categoryId: string, category: Partial<Category>) => {
        return await fetchRequest({
            route: `${CategoryRoutesEnum.CATEGORY_UPDATE}/${categoryId}`,
            method: "PUT",
            data: category,
        });
    },

    delete: async (categoryId: string) => {
        return await fetchRequest({
            route: `${CategoryRoutesEnum.CATEGORY_DELETE}/${categoryId}`,
            method: "DELETE",
        });
    }
};
